import { Typography } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useReducer, useState } from 'react';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import CustomDate from '../components/customDate';
import { format } from 'date-fns';

export default function FilterDataFasilitas(props) {
    const [tglMulai, setTglMulai] = useState(null)
    const [tglSelesai, setTglSelesai] = useState(null)
    const [userPicker, setUserPicker] = useState(null)
    const [categoryPicker, setCategoryPicker] = useState([])
    const [facilityPicker, setFacilityPicker] = useState([])
    const [subfacilityPicker, setSubfacilityPicker] = useState([])
    const [dataFasilitas, setDataFasilitas] = useState([])
    const [dataSubfasilitas, setDataSubfacilitas] = useState([])
    const [errorTglMulai, setErrorTglMulai] = useState(false)
    const [errorTglSelesai, setErrorTglSelesai] = useState(false)

    useEffect(() => {
        console.log(props);
        let user = props.saveUser && props.saveUser.id
        let idUser = props.dataUser.findIndex((val) => val.id === user)
        if (idUser > -1) {
            setUserPicker(props.dataUser[idUser])
        }
        if (props.saveTglMulai !== null) {
            setTglMulai(props.saveTglMulai)
        }
        if (props.saveTglSelesai !== null) {
            setTglSelesai(props.saveTglSelesai)
        }
        if (props.saveCategory !== null) {
            setCategoryPicker(props.saveCategory)
            if (props.saveFacility !== null) {
                let data = returnFacility(props.saveCategory)
                setDataFasilitas(data)
                setFacilityPicker(props.saveFacility)
                if (props.saveSubFacility !== null) {
                    let dataSub = returnSubFacility(props.saveFacility)
                    setDataSubfacilitas(dataSub)
                    setSubfacilityPicker(props.saveSubFacility)
                }
            }
            forceUpdate()
        }
    }, [])

    const forceUpdate = useReducer(bool => !bool)[1];

    const handleFilter = () => {
        if (tglMulai === null) {
            setErrorTglMulai(true)
        } else if (tglSelesai === null) {
            setErrorTglSelesai(true)
        } else {
            let payload
            let facilityCategoryID = []
            let facilityID = []
            let subfacilityID = []
            if (categoryPicker.length > 0) {
                categoryPicker.map((item) => {
                    facilityCategoryID.push(item.id)
                })
            }
            if (facilityPicker.length > 0) {
                facilityPicker.map((item) => {
                    facilityID.push(item.id)
                })
            }
            if (subfacilityPicker.length > 0) {
                subfacilityPicker.map((item) => {
                    subfacilityID.push(item.id)
                })
            }
            if (userPicker !== null) {
                payload = `facility_category_id=[${subfacilityID}]&facility_category_id=[${facilityCategoryID}]&facility_id=[${facilityID}]&user_id=[${userPicker.id}]&start_date=${format(new Date(tglMulai), 'yyyy-MM-dd')}&end_date=${format(new Date(tglSelesai), 'yyyy-MM-dd')}`
            } else {
                payload = `facility_category_id=[${subfacilityID}]&facility_category_id=[${facilityCategoryID}]&facility_id=[${facilityID}]&start_date=${format(new Date(tglMulai), 'yyyy-MM-dd')}&end_date=${format(new Date(tglSelesai), 'yyyy-MM-dd')}`
            }
            props.handleFilter(payload, userPicker, tglMulai, tglSelesai, categoryPicker, facilityPicker, subfacilityPicker)
        }
    }

    const handlefacility = (val) => {
        let data = props.dataFacility.filter(function (o1) {
            // filter out (!) items in result2
            return val.some(function (o2) {
                return o1.facility_category_id === o2.id;          // assumes unique id
            });
        })
        console.log(data);
        setDataFasilitas(data)
    }

    const returnFacility = (val) => {
        let data = props.dataFacility.filter(function (o1) {
            // filter out (!) items in result2
            return val.some(function (o2) {
                return o1.facility_category_id === o2.id;          // assumes unique id
            });
        })
        return data
    }

    const handleSubfacility = (val) => {
        let data = props.dataSubfacility.filter(function (o1) {
            // filter out (!) items in result2
            return val.some(function (o2) {
                return o1.facility_id === o2.id;          // assumes unique id
            });
        })
        console.log(data);
        setDataSubfacilitas(data)
    }

    const returnSubFacility = (val) => {
        let data = props.dataSubfacility.filter(function (o1) {
            // filter out (!) items in result2
            return val.some(function (o2) {
                return o1.facility_id === o2.id;          // assumes unique id
            });
        })
        return data
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Filter Data</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <Autocomplete
                        value={userPicker}
                        options={props.dataUser}
                        getOptionLabel={(option) => option.name}
                        id="tipe"
                        onChange={(event, newInputValue) => {
                            setUserPicker(newInputValue)
                        }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                label="User"
                            />
                        }
                    />
                    <div style={{ marginTop: 10 }}>
                        <Autocomplete
                            value={categoryPicker}
                            options={props.dataFacilityCategory}
                            getOptionLabel={(option) => option.queue_type_in}
                            multiple
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setCategoryPicker(newInputValue)
                                handlefacility(newInputValue)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Fasilitas Kategori"
                                />
                            }
                        />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <Autocomplete
                            value={facilityPicker}
                            options={dataFasilitas}
                            getOptionLabel={(option) => String(`${option.name} - ${option.facility_category_queue_type_in}`)}
                            multiple
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setFacilityPicker(newInputValue)
                                handleSubfacility(newInputValue)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Fasilitas"
                                />
                            }
                        />
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <Autocomplete
                            value={subfacilityPicker}
                            options={dataSubfasilitas}
                            getOptionLabel={(option) => String(`${option.name} - ${option.facilities.name}`)}
                            multiple
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setSubfacilityPicker(newInputValue)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Sub Fasilitas"
                                />
                            }
                        />
                    </div>
                    <div >
                        <CustomDate
                            value={tglMulai}
                            label={"Tanggal Mulai"}
                            maxDate={new Date()}
                            setValue={(date) => {
                                setTglMulai(date)
                                setErrorTglMulai(false)
                            }}
                        />
                        {errorTglMulai && (
                            <Typography style={{ color: 'red', fontSize: 11, textAlign: 'left', marginTop: -5 }}>Tanggal Mulai wajib diisi</Typography>
                        )}
                    </div>
                    <div >
                        <CustomDate
                            value={tglSelesai}
                            label={"Tanggal Selesai"}
                            minDate={new Date(tglMulai)}
                            maxDate={new Date()}
                            setValue={(date) => {
                                setTglSelesai(date)
                                setErrorTglSelesai(false)
                            }}
                        />
                        {errorTglSelesai && (
                            <Typography style={{ color: 'red', fontSize: 11, textAlign: 'left', marginTop: -5 }}>Tanggal Selesai wajib diisi</Typography>
                        )}
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={(e) => handleFilter()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}